<template>
	<section id="project-previews">
		<div class="container-sm is-centered center-align">
			<p>I've selected the following three projects to highlight and review, as each one had its own set of unique successes and challenges, and best demonstrates some of the skills and tools that I've used.</p>
		</div>
		<div class="container-med is-centered">
			<!-- <h1>Recent Projects</h1>
			<h2>Here are a few of the notable things I’ve worked on:</h2> -->
			<div class="grid-row grid-gutter-lrg stack-mobile">
				<div class="grid-col col-1-of-3">
					<router-link :to="{ name: 'SingleProject', params: { projectName: 'rl-hub' }}">
						<img srcset="@/assets/img/projects/previews/rl-hub-300w.jpg 300w, @/assets/img/projects/previews/rl-hub-600w.jpg 600w" sizes="300px" src="@/assets/img/projects/previews/rl-hub-300w.jpg" alt="RL HUB Banner"/>
						<span>RL HUB</span>
					</router-link>
				</div>
				<div class="grid-col col-1-of-3">
					<router-link :to="{ name: 'SingleProject', params: { projectName: 'khp-chatbot' }}">
						<img srcset="@/assets/img/projects/previews/khp-bot-300w.jpg 300w, @/assets/img/projects/previews/khp-bot-600w.jpg 600w" sizes="300px" src="@/assets/img/projects/previews/khp-bot-300w.jpg" alt="Kids Help Phone Chatbot Banner"/>
						<span>Kids Help Phone Chatbot</span>
					</router-link>
				</div>
				<div class="grid-col col-1-of-3">
					<router-link :to="{ name: 'SingleProject', params: { projectName: 'holiday-jumble' }}">
						<img srcset="@/assets/img/projects/previews/holiday-jumble-banner-300w.jpg 300w, @/assets/img/projects/previews/holiday-jumble-banner-600w.jpg 600w" sizes="300px" src="@/assets/img/projects/previews/holiday-jumble-banner-300w.jpg" alt="Holiday Jumble Banner"/>
						<span>Holiday Jumble</span>
					</router-link>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'Projects'
}
</script>

<style lang="scss">
@import 'src/assets/css/modules/colors';

#project-previews {
	// margin-top: 2rem;
	p {
		line-height: 1.6;
		margin: 0 0 3rem;
	}
	.grid-col {
		text-align: center;
	}
	a {
		display: inline-block;
		padding-bottom: 0.5rem;
		transition: 0.3s box-shadow;
		span {
			display: block;
			font-weight: 500;
			margin-top: 0.5rem;
		}
		&:hover, &:focus {
			box-shadow: 0 0 0 3px $navy; 
		}
	}
}


</style>